export const countries = [
    {
        name: "Afghanistan",
        code: "AF",
        phoneCode: "+93",
        flag: "🇦🇫",
        format: "+93 (###) ###-####",
    },
    {
        name: "Albania",
        code: "AL",
        phoneCode: "+355",
        flag: "🇦🇱",
        format: "+355 (###) ###-####",
    },
    {
        name: "Algeria",
        code: "DZ",
        phoneCode: "+213",
        flag: "🇩🇿",
        format: "+213 (###) ###-####",
    },
    {
        name: "Andorra",
        code: "AD",
        phoneCode: "+376",
        flag: "🇦🇩",
        format: "+376 (###) ###-####",
    },
    {
        name: "Angola",
        code: "AO",
        phoneCode: "+244",
        flag: "🇦🇴",
        format: "+244 (###) ###-####",
    },
    {
        name: "Argentina",
        code: "AR",
        phoneCode: "+54",
        flag: "🇦🇷",
        format: "+54 (###) ###-####",
    },
    {
        name: "Armenia",
        code: "AM",
        phoneCode: "+374",
        flag: "🇦🇲",
        format: "+374 (###) ###-####",
    },
    {
        name: "Australia",
        code: "AU",
        phoneCode: "+61",
        flag: "🇦🇺",
        format: "+61 (###) ###-####",
    },
    {
        name: "Austria",
        code: "AT",
        phoneCode: "+43",
        flag: "🇦🇹",
        format: "+43 (###) ###-####",
    },
    {
        name: "Azerbaijan",
        code: "AZ",
        phoneCode: "+994",
        flag: "🇦🇿",
        format: "+994 (###) ###-####",
    },
    {
        name: "Bahrain",
        code: "BH",
        phoneCode: "+973",
        flag: "🇧🇭",
        format: "+973 (###) ###-####",
    },
    {
        name: "Bangladesh",
        code: "BD",
        phoneCode: "+880",
        flag: "🇧🇩",
        format: "+880 (###) ###-####",
    },
    {
        name: "Belgium",
        code: "BE",
        phoneCode: "+32",
        flag: "🇧🇪",
        format: "+32 (###) ###-####",
    },
    {
        name: "Bhutan",
        code: "BT",
        phoneCode: "+975",
        flag: "🇧🇹",
        format: "+975 (###) ###-####",
    },
    {
        name: "Brazil",
        code: "BR",
        phoneCode: "+55",
        flag: "🇧🇷",
        format: "+55 (###) ###-####",
    },
    {
        name: "Canada",
        code: "CA",
        phoneCode: "+1",
        flag: "🇨🇦",
        format: "+1 (###) ###-####",
    },
    {
        name: "China",
        code: "CN",
        phoneCode: "+86",
        flag: "🇨🇳",
        format: "+86 (###) ###-####",
    },
    {
        name: "Denmark",
        code: "DK",
        phoneCode: "+45",
        flag: "🇩🇰",
        format: "+45 (###) ###-####",
    },
    {
        name: "Egypt",
        code: "EG",
        phoneCode: "+20",
        flag: "🇪🇬",
        format: "+20 (###) ###-####",
    },
    {
        name: "Finland",
        code: "FI",
        phoneCode: "+358",
        flag: "🇫🇮",
        format: "+358 (###) ###-####",
    },
    {
        name: "France",
        code: "FR",
        phoneCode: "+33",
        flag: "🇫🇷",
        format: "+33 (###) ###-####",
    },
    {
        name: "Germany",
        code: "DE",
        phoneCode: "+49",
        flag: "🇩🇪",
        format: "+49 (###) ###-####",
    },
    {
        name: "India",
        code: "IN",
        phoneCode: "+91",
        flag: "🇮🇳",
        format: "+91 (###) ###-####",
    },
    {
        name: "Japan",
        code: "JP",
        phoneCode: "+81",
        flag: "🇯🇵",
        format: "+81 (###) ###-####",
    },
    {
        name: "Kenya",
        code: "KE",
        phoneCode: "+254",
        flag: "🇰🇪",
        format: "+254 (###) ###-####",
    },
    {
        name: "Malaysia",
        code: "MY",
        phoneCode: "+60",
        flag: "🇲🇾",
        format: "+60 (###) ###-####",
    },
    {
        name: "Netherlands",
        code: "NL",
        phoneCode: "+31",
        flag: "🇳🇱",
        format: "+31 (###) ###-####",
    },
    {
        name: "New Zealand",
        code: "NZ",
        phoneCode: "+64",
        flag: "🇳🇿",
        format: "+64 (###) ###-####",
    },
    {
        name: "Nigeria",
        code: "NG",
        phoneCode: "+234",
        flag: "🇳🇬",
        format: "+234 (###) ###-####",
    },
    {
        name: "Pakistan",
        code: "PK",
        phoneCode: "+92",
        flag: "🇵🇰",
        format: "+92 (###) ###-####",
    },
    {
        name: "Philippines",
        code: "PH",
        phoneCode: "+63",
        flag: "🇵🇭",
        format: "+63 (###) ###-####",
    },
    {
        name: "Russia",
        code: "RU",
        phoneCode: "+7",
        flag: "🇷🇺",
        format: "+7 (###) ###-####",
    },
    {
        name: "KSA",
        code: "SA",
        phoneCode: "+966",
        flag: "🇸🇦",
        format: "+966 (###) ###-####",
    },
    {
        name: "Singapore",
        code: "SG",
        phoneCode: "+65",
        flag: "🇸🇬",
        format: "+65 (###) ###-####",
    },
    {
        name: "South Africa",
        code: "ZA",
        phoneCode: "+27",
        flag: "🇿🇦",
        format: "+27 (###) ###-####",
    },
    {
        name: "South Korea",
        code: "KR",
        phoneCode: "+82",
        flag: "🇰🇷",
        format: "+82 (###) ###-####",
    },
    {
        name: "Spain",
        code: "ES",
        phoneCode: "+34",
        flag: "🇪🇸",
        format: "+34 (###) ###-####",
    },
    {
        name: "Sweden",
        code: "SE",
        phoneCode: "+46",
        flag: "🇸🇪",
        format: "+46 (###) ###-####",
    },
    {
        name: "Switzerland",
        code: "CH",
        phoneCode: "+41",
        flag: "🇨🇭",
        format: "+41 (###) ###-####",
    },
    {
        name: "Thailand",
        code: "TH",
        phoneCode: "+66",
        flag: "🇹🇭",
        format: "+66 (###) ###-####",
    },
    {
        name: "Turkey",
        code: "TR",
        phoneCode: "+90",
        flag: "🇹🇷",
        format: "+90 (###) ###-####",
    },
    {
        name: "UAE",
        code: "AE",
        phoneCode: "+971",
        flag: "🇦🇪",
        format: "+971 (###) ###-####",
    },
    {
        name: "United Kingdom",
        code: "GB",
        phoneCode: "+44",
        flag: "🇬🇧",
        format: "+44 (###) ###-####",
    },
    {
        name: "United States",
        code: "US",
        phoneCode: "+1",
        flag: "🇺🇸",
        format: "+1 (###) ###-####",
    },
    {
        name: "Vietnam",
        code: "VN",
        phoneCode: "+84",
        flag: "🇻🇳",
        format: "+84 (###) ###-####",
    },
    {
        name: "Zambia",
        code: "ZM",
        phoneCode: "+260",
        flag: "🇿🇲",
        format: "+260 (###) ###-####",
    },
    {
        name: "Zimbabwe",
        code: "ZW",
        phoneCode: "+263",
        flag: "🇿🇼",
        format: "+263 (###) ###-####",
    },
    {
        name: "Kuwait",
        code: "KW",
        phoneCode: "+965",
        flag: "🇰🇼",
        format: "+965 #### ####",
    },
    {
        name: "Morocco",
        code: "MA",
        phoneCode: "+212",
        flag: "🇲🇦",
        format: "+212 (##) #######",
    },
    {
        name: "Tunisia",
        code: "TN",
        phoneCode: "+216",
        flag: "🇹🇳",
        format: "+216 ## ### ###",
    },
    {
        name: "Switzerland",
        code: "CH",
        phoneCode: "+41",
        flag: "🇨🇭",
        format: "+41 ## ### ## ##",
    },
];
export const phoneNumberRules = {
    "+93": 9, // Afghanistan
    "+355": 9, // Albania
    "+213": 9, // Algeria
    "+376": 6, // Andorra
    "+244": 9, // Angola
    "+54": 10, // Argentina
    "+374": 8, // Armenia
    "+61": 9, // Australia
    "+43": 10, // Austria
    "+994": 9, // Azerbaijan
    "+973": 8, // Bahrain
    "+880": 10, // Bangladesh
    "+32": 9, // Belgium
    "+975": 8, // Bhutan
    "+55": 11, // Brazil
    "+1": 10, // Canada / United States
    "+86": 11, // China
    "+45": 8, // Denmark
    "+20": 10, // Egypt
    "+358": 9, // Finland
    "+33": 9, // France
    "+49": 10, // Germany
    "+91": 10, // India
    "+81": 10, // Japan
    "+254": 9, // Kenya
    "+60": 9, // Malaysia
    "+31": 9, // Netherlands
    "+64": 9, // New Zealand
    "+234": 10, // Nigeria
    "+92": 10, // Pakistan
    "+63": 10, // Philippines
    "+7": 10, // Russia
    "+966": 9, // KSA
    "+65": 8, // Singapore
    "+27": 9, // South Africa
    "+82": 10, // South Korea
    "+34": 9, // Spain
    "+46": 9, // Sweden
    "+41": 9, // Switzerland
    "+66": 9, // Thailand
    "+90": 10, // Turkey
    "+971": 9, // UAE
    "+44": 10, // United Kingdom
    "+84": 9, // Vietnam
    "+260": 9, // Zambia
    "+263": 9, // Zimbabwe
    "+965": 9, // Kuwait
};
